import type { PartnerBank, SupplierPartner, SupplierPayment } from './types';
import { f1 } from './view';
import { norm } from './payables';
import { useT } from '@hana/i18n';
import s from './supplierPay.module.css';
import './finance.i18n';

// Mint-SupplierPay › tab Phiếu chi (TblSupplierPayment): 8 cột, chip rủi ro, chân bảng. TIỀN → màn đã nằm sau quyền money.
const STATE = {
  wait: ['Pending · chờ duyệt', 'warn'],
  ok: ['RQ Payment · chờ chi', 'pri'],
  paid: ['Done · đã chi', 'ok'],
} as const;
const COLS: readonly (readonly [string, 'l' | 'r'])[] = [
  ['Phiếu chi · ngày', 'l'], ['Đối tác · nội dung CK', 'l'], ['Loại', 'l'], ['TK chi', 'l'], ['Số tiền', 'r'], ['Kiểm rủi ro', 'l'], ['Lập → duyệt', 'l'], ['Trạng thái', 'l'],
];

/** Nhãn rủi ro đúng chữ của board (kèm số mẫu của phiếu vàng). */
export function payRisks(p: SupplierPayment, bank: PartnerBank): { k: string; block: boolean }[] {
  const out: { k: string; block: boolean }[] = [];
  if (bank === 'locked') out.push({ k: 'Đối tác tạm khoá chi', block: true });
  if (bank === 'changed') out.push({ k: 'TK nhận vừa đổi', block: true });
  if (bank === 'unverified') out.push({ k: 'TK chưa xác minh', block: true });
  if (bank === 'shared') out.push({ k: 'TK dùng chung đối tác khác', block: false });
  if (p.extraRisk.includes('over')) out.push({ k: 'Vượt tổng DN 2,6 tr', block: true });
  if (p.extraRisk.includes('dup')) out.push({ k: 'Trùng payment TTS26039540', block: true });
  if (p.extraRisk.includes('mix')) out.push({ k: 'Trộn deposit với cước', block: false });
  if (!p.docs.length) out.push({ k: 'Chưa link chứng từ', block: true });
  return out;
}

export function PayTab({ pays, partners, q, approver, onOpen }: { pays: readonly SupplierPayment[]; partners: readonly SupplierPartner[]; q: string; approver: string; onOpen: (ref: string) => void }) {
  const tx = useT();
  const bank = (k: string): PartnerBank => partners.find((x) => x.key === k)?.bank ?? 'ok';
  const rows = q ? pays.filter((p) => norm(p.ref + p.partner + p.content).includes(norm(q))) : pays;
  return (
    <section className={`${s.card} ${s.payCard}`} aria-label="Phiếu chi đối tác">
      <table className={s.payTable}>
        <thead>
          <tr>{COLS.map(([k, al]) => <th key={k} className={al === 'r' ? s.r : undefined}>{k}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((p) => {
            const [label, tone] = STATE[p.state];
            const risks = payRisks(p, bank(p.partner));
            return (
              <tr key={p.ref} onClick={() => onOpen(p.ref)}>
                <td><b className={s.link}>{p.ref}</b><div>{p.date}</div></td>
                <td><b>{p.partner}</b><div>{p.content}</div></td>
                <td><span className={s.cls}>{p.cls}</span></td>
                <td className={s.tx2}>{p.account}</td>
                <td className={s.r}><b>{f1(p.amount)}</b><div>{p.docs.length} DN</div></td>
                <td>
                  <div className={s.risks}>
                    {risks.slice(0, 2).map((r) => <span key={r.k} className={`${s.risk} ${r.block ? s.st_err : s.st_warn}`}>{r.k}</span>)}
                    {!risks.length && <span className={s.okc}>{tx('fn.noWarn')}</span>}
                  </div>
                </td>
                <td className={s.tx2}>{p.maker} → {p.state === 'wait' ? approver : p.approver}</td>
                <td><span className={`${s.pst} ${s[`pst_${tone}`]}`}><i />{label}</span></td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className={s.foot}><span>{tx('fn.mTr')} · {tx('fn.payLegend')}</span><span>{tx('fn.payCount', { n: pays.length })}</span></div>
    </section>
  );
}
